<!-- <app-property-search-form *ngIf="showform==true"></app-property-search-form> -->
<app-property-search-results 
  [rows]="rows"
  [lazy]="lazyLoad"
  [paginator]="paginate"
  [value]="properties" 
  [pageChange]="loadData"></app-property-search-results>
